import React, { useCallback, useEffect, useState } from 'react';
import service from '../../../services/usuarios';
import Listagem from '../crud/Listagem';

const ConsumidorFinalListagem = props => {

    const config = {
        columns: [
            { label: "Nome", field: "nome" },
            { label: "E-mail", field: "email" },
        ],
        pagination: {
            limit: 10
        },
        sort: 'nome',
        search: [
            { label:'Nome', field: 'nome', operators: ['contains', 'not_contains'] },
            { label: "E-mail", field: "email", operators: ['contains', 'not_contains'] }
        ]
    }

    const [users, setUsers] = useState({ rows: [], total: 0 });
    const [loadingList, setLoadingList] = useState(true);

    const getList = useCallback(async (params, skip) => {
        setLoadingList(true);
        params.push({field: "grupo", operator: "equal", value: "60d32d076b3ea11d22546d16"});
        params.push({field: "processado", operator: "equal", value: true});
        params.push({field: "recusado", operator: "equal", value: false});
        const result = await service.getList({ params, sort: config.sort }, skip, config.pagination.limit);
        setLoadingList(false);
        setUsers(result);
    }, [config.pagination.limit, config.sort]);

    const upsert = async (obj, id) => {
        setLoadingList(true);
        const result = await service.upsert(obj, id);
        setLoadingList(false);
        return result;
    }

    useEffect(() => {
        getList([], 0);
    }, [getList]);

    return (
        <>
            <Listagem registros={users} service={{ getList, upsert }} config={config} loadingList={loadingList} rota="consumidorFinal" />
        </>
    )
};

export default ConsumidorFinalListagem;